import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './ChatToast.css';

const ChatToast = ({
  open,
  title,
  body,
  actionLabel,
  onAction,
  onClose,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const timer = window.setTimeout(() => {
      if (typeof onClose === 'function') onClose();
    }, 3000);
    return () => window.clearTimeout(timer);
  }, [open, onClose, title, body]);

  if (!open) return null;

  return createPortal(
    <div className="chat-toast" role="status" aria-live="polite">
      <div className="chat-toast-icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 6.5A3.5 3.5 0 018.5 3h7A3.5 3.5 0 0119 6.5v6A3.5 3.5 0 0115.5 16H10l-4.2 3.15c-.55.41-1.3-.02-1.3-.72V6.5z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="chat-toast-copy">
        <p className="chat-toast-title">{title}</p>
        {body ? <p className="chat-toast-body">{body}</p> : null}
      </div>
      <div className="chat-toast-actions">
        {typeof onAction === 'function' && actionLabel ? (
          <button type="button" className="chat-toast-action" onClick={onAction}>
            {actionLabel}
          </button>
        ) : null}
        <button type="button" className="chat-toast-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ChatToast;
